import React, { useRef, useEffect, useCallback } from "react";
import MagazineCard from "./MagazineCard";

const magazines = [
   // Revistas nuevas
   {
      month: "Julio 2026",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1784735919/CCED/Portada_julio_oor1bz.png",
      pdfUrl: "https://drive.google.com/file/d/13VunYQ7POi7RjMYUmG0KyEUxZUu6_wCY/view",
   },
   {
      month: "Junio 2026",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1781884717/CCED/Portada_junio_2026_djrxil.png",
      pdfUrl: "https://drive.google.com/file/d/1Wnxg7ymVdaw2l0XIrngD9gqeBlk35aCI/view",
   },
   {
      month: "Mayo 2026",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1780329630/CCED/Portada_mayo_ypybr5.png",
      pdfUrl: "https://drive.google.com/file/d/1iuKxl0BgcJRe4hLC6U2aC8HLS25DCYj1/view",
   },
   {
      month: "Abril 2026",
      image: "https://res.cloudinary.com/dvovfc3gb/image/upload/v1/10._maderadelider_abril2026_c9xleq.jpg",
      pdfUrl: "https://drive.google.com/file/d/18HegzinXvHN93xU_fohkU4cHRI1vdNey/view",
   },
   {
      month: "Marzo 2026",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1777924959/CCED/Portada_marzo_3_r9jl0a.png",
      pdfUrl: "https://drive.google.com/file/d/1WSnwgG1RhDLve6TNxg4c8GTwuw9sjPQw/view",
   },
   {
      month: "Febrero 2026",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1777924955/CCED/Portada_febrero_idmew7.png",
      pdfUrl: "https://drive.google.com/file/d/1Tfd1w1Z8hM7Ac5hkMeoNOjfzuhXy3jOI/view",
   },
   {
      month: "Enero 2026",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1767712611/CCED/Portada_enero_c1cfdb948be8.png",
      pdfUrl: "https://drive.google.com/file/d/1GgSN6xrKkEpwEzwR5_PkSWEe0GUDUGJ4/view",
   },
   {
      month: "Noviembre 2025",
      image: "https://res.cloudinary.com/dvovfc3gb/image/upload/v1/6._maderadelider_noviembre2025_removed_b0rlwx.jpg",
      pdfUrl: "https://drive.google.com/file/d/1uXKiw7bnrWnYbbUo75S8ic7Qmsi3s0jU/view",
   },
   {
      month: "Septiembre 2025",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1757004744/CCED/e3e82da5-e77b-4658-9c47-ca44fe953655.png",
      pdfUrl: "https://drive.google.com/file/d/1KJTcxkTW16aHveh2DpMWtAezKNYCsBC0/view?usp=sharing",
   },
   {
      month: "Agosto 2025",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1754926975/CCED/b861207a-4bac-471c-88df-788053f1524a.png",
      pdfUrl: "https://drive.google.com/file/d/1BQwI6Sk60xFYLddT_E0GBJWH9mvy0uyb/view",
   },
   {
      month: "Julio 2025",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1752688141/CCED/3._Portada_julio_3_2_ofafhk.png",
      pdfUrl: "https://drive.google.com/file/d/17WcjJn3A6kspe-9JJ4kXIjVn_YZukRKL/view",
   },
   {
      month: "Mayo 2025",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1752600104/CCED/2._Portada_mayo_3_evmaaw.png",
      pdfUrl: "https://drive.google.com/file/d/1XkcGqKNCK5f5R5-1UHK_H6bqrcxzUWeY/view",
   },
   {
      month: "Marzo 2025",
      image: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1752684123/CCED/1._Portada_marzo_2_1_vbxemx.png",
      pdfUrl: "https://drive.google.com/file/d/15HVn2Mk4upDcjWfBOKjhuTn8LILk9lFK/view",
   },
];

const MagazineList: React.FC = () => {
   const scrollRef = useRef<HTMLDivElement>(null);

   const getStep = useCallback(() => {
      const container = scrollRef.current;
      if (!container || container.children.length === 0) return 0;

      const first = container.children[0] as HTMLElement;
      const cardW = first.getBoundingClientRect().width;

      const styles = window.getComputedStyle(container);
      const gap = parseFloat(styles.columnGap || "0");

      return cardW + gap;
   }, []);

   useEffect(() => {
      if (scrollRef.current) scrollRef.current.scrollLeft = 0;
   }, []);

   const handleNext = () => {
      const c = scrollRef.current;
      if (!c) return;

      const step = getStep();
      if (!step) return;

      const max = c.scrollWidth - c.clientWidth;

      if (c.scrollLeft + step >= max - 1) {
         c.scrollTo({ left: max, behavior: "smooth" });

         setTimeout(() => {
            c.scrollTo({ left: 0, behavior: "auto" });
         }, 320);
      } else {
         c.scrollBy({ left: step, behavior: "smooth" });
      }
   };

   const handlePrev = () => {
      const c = scrollRef.current;
      if (!c) return;

      const step = getStep();
      if (!step) return;

      const max = c.scrollWidth - c.clientWidth;

      if (c.scrollLeft < step) {
         c.scrollLeft = max;
         return;
      }

      c.scrollBy({ left: -step, behavior: "smooth" });
   };

   const fewMagazines = magazines.length <= 3;

   return (
      <div className="w-full flex justify-center">
         <div className="relative w-[90%] max-w-[1100px]">
            <div
               ref={scrollRef}
               className={`flex ${fewMagazines
                     ? "justify-center"
                     : "overflow-x-auto scroll-smooth snap-x snap-mandatory custom-scroll-hide"
                  } gap-4 mx-auto ${!fewMagazines ? "px-[60px]" : ""}`}
            >
               {magazines.map((mag, index) => (
                  <div
                     key={index}
                     className={`flex-shrink-0 ${fewMagazines ? "w-[40%] sm:w-[280px]" : "w-[25%]"} snap-start`}
                  >
                     <MagazineCard month={mag.month} image={mag.image} pdfUrl={mag.pdfUrl} />
                  </div>
               ))}
            </div>

            {!fewMagazines && (
               <>
                  <button
                     onClick={handlePrev}
                     className="absolute left-[-40px] top-1/2 transform -translate-y-1/2 rounded-full p-2 hover:scale-110 transition w-[45px] h-[45px] z-10"
                     aria-label="Anterior"
                  >
                     <img
                        src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1752602267/CCED/Component_12_ww86u6.png"
                        alt="Anterior"
                        className="w-full h-full object-contain scale-x-[-1]"
                     />
                  </button>
                  <button
                     onClick={handleNext}
                     className="absolute right-[-40px] top-1/2 transform -translate-y-1/2 rounded-full p-2 hover:scale-110 transition w-[45px] h-[45px] z-10"
                     aria-label="Siguiente"
                  >
                     <img
                        src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1752602267/CCED/Component_12_ww86u6.png"
                        alt="Siguiente"
                        className="w-full h-full object-contain"
                     />
                  </button>
               </>
            )}
         </div>
      </div>
   );
};

export default MagazineList;